export enum StoreErrorFlagId {
	CONVERSATION_FORBIDDEN = 'conversationForbidden',
	CONVERSATION_HISTORY_LOAD_FAILED = 'conversationHistoryLoadFailed',
}
